// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Ynmg","item":"PaymentsMobile_item__1kSaD","label":"PaymentsMobile_label__Em_qG","amount":"PaymentsMobile_amount__2w17Z"};